import { useMediaQuery } from '@mui/material'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import { useEventsRoadmapQuery } from 'Queries/Events'

import RoadMapScroll from '../../Components/Roadmap/RoadMapScroll'
import { BREAKPOINT_MIN_MD } from '../../Theme/stylesUtil'

const EventsRoadmap = () => {
  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)
  const paddingTop = isBiggerThanMDScreen ? '96px' : '60px'
  const { data: roadmapContestList } = useEventsRoadmapQuery()

  return (
    <Container>
      <Typography
        variant="h3"
        color="text.primary"
        sx={{ paddingTop, paddingBottom: '24px' }}
      >
        Events Roadmap
      </Typography>
      <RoadMapScroll roadMap={roadmapContestList} />
    </Container>
  )
}

export default EventsRoadmap
